import React, { useMemo, useState } from 'react';

import MapLayersView from './MapLayers.view';
import { AppState } from 'models/app-store';
import { useSelector } from 'react-redux';
import { RiChargingPileFill } from 'react-icons/ri';
import { IPickedLayer, LayersTypes } from './MapLayers.model';
import { ConnectorPowerLabel, ConnectorStatus } from 'utils/enums/chargingType';

type Props = {
  onClickLayer: (layer: LayersTypes | null) => void;
  showLayerType: LayersTypes | null;
  layerTypeOptions?: LayersTypes[];
  selectedPowerType?: ConnectorPowerLabel[];
  onSelectPowerType?: (powerType: ConnectorPowerLabel) => void;
  connectorStatus?: ConnectorStatus;
  onConnectorStatusChange?: (status: ConnectorStatus) => void;
};

const MapLayers: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const [showMapLayersOptionState, setShowMapLayersOptionState] = useState<boolean>(false);
  const darkMode = useSelector((state: AppState) => state.ui.darkMode);

  const pickedLayer: IPickedLayer | null = useMemo(() => {
    return props.showLayerType === LayersTypes.Booking
      ? { icon: 'dots', name: 'Bookings', type: LayersTypes.Booking }
      : props.showLayerType === LayersTypes.EV
        ? { icon: RiChargingPileFill, name: 'EV', type: LayersTypes.EV }
        : props.showLayerType === LayersTypes.Heat
          ? { icon: 'heatMap', name: 'Heat Map', type: LayersTypes.Heat }
          : null;
  }, [props.showLayerType]);

  return (
    <MapLayersView
      onLeaveMapLayer={() => setShowMapLayersOptionState(() => false)}
      onEnterMapLayer={() => setShowMapLayersOptionState(() => true)}
      showMapLayersOption={showMapLayersOptionState}
      onClickLayer={props.onClickLayer}
      pickedLayer={pickedLayer}
      darkMode={darkMode}
      layerTypeOptions={props.layerTypeOptions}
      showLayerType={props.showLayerType}
      selectedPowerType={props.selectedPowerType}
      onSelectPowerType={props.onSelectPowerType}
      connectorStatus={props.connectorStatus}
      onConnectorStatusChange={props.onConnectorStatusChange}
    >
      {props.children}
    </MapLayersView>
  );
};

MapLayers.displayName = 'MapLayers';
MapLayers.defaultProps = {};

export default MapLayers;
